import { Box, Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { useNavigate } from "react-router";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

const HeaderSection = ({ cmCount }) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.white.main,
        display: "flex",
        justifyContent: "space-between",
        height: "58px",
        borderBottom: "2px solid",
        borderColor: theme.palette.black.main,
        overflowX: "hidden",
        padding: "14px 20px 20px 12px",
        fontWeight: 600,
        fontSize: "24px",
        borderRadius: "16px 16px 0px 0px",
        position: "fixed",
        top: 0,
        width: "100%",
        zIndex: 3,
      }}
    >
      {cmCount >= 0 ? (
        <>
          {cmCount === 0 && "Comments"}
          {cmCount === 1 && cmCount + " Comment"}
          {cmCount > 1 && cmCount + " Comments"}
        </>
      ) : (
        <Skeleton width={140} height={32} />
      )}

      <Box
        onClick={() => navigate(-1)}
        sx={{
          display: "flex",
          alignItems: "start",
          cursor: "pointer",
          pt: "5px",
        }}
      >
        <CloseRoundedIcon />
      </Box>
    </Box>
  );
};

export default HeaderSection;
